var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.maskShow),expression:"maskShow"}],staticClass:"dialogs"},[_c('p',{staticClass:"tip"},[_vm._v("鉴于钉钉设计原因, 提交后，您的历史账号及关联的相关文件、群聊信息可能会丢失。")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":function($event){return _vm.confirm()}}},[_vm._v("我知道了")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a51cc00c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/tips.vue
// module id = Piys
// module chunks = 1